import { render, staticRenderFns } from "./dbChoiceDonationLocation.vue?vue&type=template&id=5e58a232&scoped=true"
import script from "./dbChoiceDonationLocation.vue?vue&type=script&lang=js"
export * from "./dbChoiceDonationLocation.vue?vue&type=script&lang=js"
import style0 from "./dbChoiceDonationLocation.vue?vue&type=style&index=0&id=5e58a232&prod&lang=css"
import style1 from "./dbChoiceDonationLocation.vue?vue&type=style&index=1&id=5e58a232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e58a232",
  null
  
)

export default component.exports